import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';

export interface CollisionMeshLoadResult {
  group: THREE.Group;
  meshes: THREE.Mesh[];
}

// Draco decoder CDN（gstatic 提供 wasm/js 解码器）
const DRACO_DECODER_PATH = 'https://www.gstatic.com/draco/versioned/decoders/1.5.7/';

/**
 * 加载 GLB/GLTF 碰撞模型，递归提取所有 Mesh geometry。
 * 内置 DRACOLoader 以支持 Draco 压缩的 GLB。
 */
export class CollisionMeshLoader {
  private loader: GLTFLoader;

  constructor() {
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath(DRACO_DECODER_PATH);
    dracoLoader.setDecoderConfig({ type: 'js' });

    this.loader = new GLTFLoader();
    this.loader.setDRACOLoader(dracoLoader);
  }

  async load(url: string): Promise<CollisionMeshLoadResult> {
    const gltf = await this.loader.loadAsync(url);
    const group = gltf.scene;
    const meshes: THREE.Mesh[] = [];
    group.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        meshes.push(child);
      }
    });
    return { group, meshes };
  }
}
